import { Notes } from "./IntlBits";

export function CountryCoverage({ countries }) {
  return (
    <div data-testid="sci-intl-countries" className="flex flex-wrap gap-2">
      {countries.map((c) => (
        <span key={c.code} data-testid={`sci-intl-country-${c.code.toLowerCase()}`} title={c.note}
          className={`rounded-full border px-3 py-1 text-xs ${c.covered ? "border-[#002147] bg-[#002147] text-white" : "border-dashed border-stone-300 text-stone-500"}`}>
          {c.name}{c.covered ? "" : " · costs only"}
        </span>
      ))}
      <p className="w-full text-xs text-stone-500" data-testid="sci-intl-countries-note">
        Tuition and living costs: all eight countries (with gaps listed). Graduate earnings, occupation pay and loan rules: UK and US only so far.
      </p>
    </div>
  );
}

export function Definitions({ defs, employers }) {
  const row = (k, v, testId) => (
    <div key={k} data-testid={testId} className="rounded-lg border border-stone-200 bg-white p-4">
      <p className="text-sm font-medium text-stone-900">{v.label}{v.shown === false ? " · not shown" : ""}</p>
      <p className="mt-1 text-xs text-stone-600">{v.means}</p>
      <p className="mt-1 text-xs text-stone-500">{v.rule}</p>
    </div>
  );
  return (
    <div data-testid="sci-intl-definitions" className="space-y-6">
      <div className="grid gap-3 md:grid-cols-3">{Object.entries(defs.figure_kinds).map(([k, v]) => row(k, v, `sci-intl-def-${k}`))}</div>
      <div className="grid gap-3 md:grid-cols-3">{Object.entries(defs.employer_kinds).map(([k, v]) => row(k, v, `sci-intl-def-${k}`))}</div>
      <p data-testid="sci-intl-employers-note" className="text-xs italic text-stone-500">{employers.note}</p>
    </div>
  );
}

export function SourcesQa({ d }) {
  return (
    <Notes testId="sci-intl-qa-notes" label="All sources, checks and gaps" className="">
    <div data-testid="sci-intl-qa" className="grid gap-6 lg:grid-cols-2">
      <div>
        <p data-testid="sci-intl-qa-summary" className="text-sm text-stone-700">
          {d.qa.verified} of {d.qa.figures} figures verified against their source · {d.qa.cost_quotes_checked} cost and {d.qa.loan_quotes_checked} loan-rule figures matched on source
        </p>
        <ul className="mt-3 space-y-2">
          {d.qa.missing.map((m) => (
            <li key={m.id} data-testid={`sci-intl-qa-missing-${m.id}`} className="text-xs text-stone-600"><span className="font-medium">{m.country} · {m.label}:</span> {m.reason}</li>
          ))}
        </ul>
      </div>
      <ul className="space-y-3" data-testid="sci-intl-sources">
        {Object.values(d.sources).map((s) => (
          <li key={s.id} data-testid={`sci-intl-source-${s.id}`} className="text-xs text-stone-600">
            <a href={s.url} target="_blank" rel="noreferrer" className="font-medium text-stone-800 underline decoration-stone-300 underline-offset-2">{s.title}</a>
            <span className="block">{s.publisher} · {s.published}{s.retrieved_at ? ` · retrieved ${s.retrieved_at}` : ""} · {s.licence}</span>
            {s.notes && <span className="block italic text-stone-500">{s.notes}</span>}
          </li>
        ))}
      </ul>
    </div>
    </Notes>
  );
}
